module.exports = __webpack_public_path__ + "static/favicon-affc8af7f9698475f1fe79a8edd7e2bd.ico";